import {Injectable} from '@angular/core';
import {RequestService} from '../../../service/request.service';
import {WsDaoEventEntityType, WsInsuranceSubscriptionSnapshot, WsRef} from '@lifeislife/lifeislife-ws-api';
import {CachedWsResourceClient} from '../../../private_util/client/cached-http-ws-Resource-client';
import {AuthProvider} from '../../../domain/auth/auth-provider';
import {AppConfigService} from '../../../../service/config/app-config.service';
import {ResourceCacheService} from '../../../../util/cache/resource-cache.service';

@Injectable({
  providedIn: 'root',
})
export class InsuranceSubscriptionSnapshotWsClient extends CachedWsResourceClient<WsInsuranceSubscriptionSnapshot, WsRef<WsInsuranceSubscriptionSnapshot>> {

  constructor(private injectedRequestService: RequestService,
              private injectedAuthService: AuthProvider,
              private injectectedCacheService: ResourceCacheService,
              private injectedAppConfigService: AppConfigService) {
    super('/front/insuranceSubscriptionSnapshot', injectedAppConfigService, injectedRequestService, injectedAuthService,
      WsDaoEventEntityType.INSURANCE_SUBSCRIPTION_SNAPSHOT, injectectedCacheService);
  }

}
